var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81V16.18C2 19.82 4.17 21.99 7.81 21.99H16.18C19.82 21.99 21.99 19.82 21.99 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#EBF3FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4699 15.0398C11.5399 15.1098 11.6199 15.1598 11.7099 15.1998C11.7999 15.2398 11.8999 15.2598 11.9999 15.2598C12.0999 15.2598 12.1899 15.2398 12.2899 15.1998C12.3799 15.1598 12.4599 15.1098 12.5299 15.0398L15.5299 12.0398C15.8199 11.7498 15.8199 11.2698 15.5299 10.9798C15.2399 10.6898 14.7599 10.6898 14.4699 10.9798L12.7499 12.6998V6.50977C12.7499 6.09977 12.4099 5.75977 11.9999 5.75977C11.5899 5.75977 11.2499 6.09977 11.2499 6.50977V12.6998L9.52994 10.9798C9.23994 10.6898 8.75994 10.6898 8.46994 10.9798C8.17994 11.2698 8.17994 11.7498 8.46994 12.0398L11.4699 15.0398Z",
    fill: "#117FD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7099 16.28C18.5799 15.89 18.1599 15.68 17.7599 15.81C14.0399 17.05 9.94994 17.05 6.22994 15.81C5.83994 15.68 5.40994 15.89 5.27994 16.28C5.14994 16.67 5.35994 17.1 5.74994 17.23C7.75994 17.9 9.86993 18.24 11.9899 18.24C14.1099 18.24 16.2199 17.9 18.2299 17.23C18.6299 17.09 18.8399 16.67 18.7099 16.28Z",
    fill: "#117FD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadnew);
export default __webpack_public_path__ + "static/media/downloadnew.86342097f1c0c64617858030e8f98160.svg";
export { ForwardRef as ReactComponent };